module.exports = __webpack_public_path__ + "static/media/iphone_11_space_grey.66e9e181.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/custom-products/iphone/iphone_11_space_grey.png
// module id = 2072
// module chunks = 0